import ReconnectingWebSocket from "reconnecting-websocket";
// import { WebSocketUrl } from "../config/index";
import store from '../store/index'
import { selectPackageListByQuery, queryOrderByUseId, getMinChatLinkCountsServiceIp } from '../network/api'
var websocket = null
import { ElNotification, ElMessage } from "element-plus";
import dayjs from "dayjs";
export const InitWebSocket = () => {



    const reateLinkAndSendheartBeat = () => {
        let message = initNullMessagePojo();
        message.type = "create_link";
        websocket.send(JSON.stringify(message));
        setInterval(() => {
            let _message = initNullMessagePojo();
            _message.type = "heartbeat_check";
            websocket.send(JSON.stringify(_message));
        }, 10000);
    }

    const initNullMessagePojo = () => {
        let cfUserMessage = {
            id: "",
            fromUid: "",
            toUid: "",
            groupId: "",
            status: 0,
            contents: "",
            type: 0,
            client: "",
            ip: "",
            createTime: 0,
            receiveTime: 0,
        };

        let message = {
            type: "",
            cfUserMessage: cfUserMessage,
            ext: "",
            token: localStorage.getItem("token"),
        };
        return message;
    }

    // 向Store推送消息
    const pushStoreData = (data, type) => {
        const carParkId = type == 'out' ? data.cfCarPark.id : data.carParkId
        if (type === 'out') store.commit('SETOUT', data)
        if (type === 'in') store.commit('SETIN', data)
        // 判断是用来选择哪个停车场 就推哪个停车场的图片
        if (carParkId === store.getters.carParkId) {
            if (type === 'out') {
                store.commit('SETOUTIMAGE', {
                    outImage: data.cfCarParkUseLog.outBigImage,
                    outSmallImage: data.cfCarParkUseLog.outSmallImage
                })
            } else {
                store.commit('SETINIMAGE', {
                    inImage: data.inBigImage,
                    inSmallImage: data.inSmallImage,
                })
            }
        }
    }
    // 异常推送
    const notifStoreData = (data) => {
        store.commit('SETERR', data)
    }
    // 获取账单信息
    const getQueryOrderByUseId = async (carParkUseLog) => {
        const { data, code } = await queryOrderByUseId(carParkUseLog.id);
        console.log('获取账单信息', data);
        console.log(data.cfCarParkUseLog);
        if (code != 10002) return
        if (store.state.globalConfig.promptChargeOutCar) {
            if (data.cfOrder.amountsPayable > 0) {
                pushStoreData(data, 'out')
            }
        } else {
            pushStoreData(data, 'out')
        }
        // 黑名单
        console.log(carParkUseLog, '车辆信息')
        if (carParkUseLog.data.cfCarParkCarType.name == '黑名单') {
            carParkUseLog.oddata = data
            notifStoreData(carParkUseLog)
        }
        if (carParkUseLog.data.cfCarParkCarType.name == '月租车') {
            if (!dayjs(carParkUseLog.data.endTime).isAfter(dayjs())) {
                carParkUseLog.oddata = data
                notifStoreData(carParkUseLog)
            }
        }

        if (data.cfCouponList != "" && data.cfCouponList.length > 0) {
            data.cfOrder.couponDenomination =
                data["cfCouponList"][0]["denomination"];
        } else {
            data.cfOrder.couponDenomination = 0;
        }

        if (
            data.cfOrder.amountsPayable - data.cfOrder.couponDenomination > 0 &&
            data.cfOrder.status == 0 &&
            !data.cfOrder.collectionShopId && data.cfOrder.payTime === 0 && carParkUseLog.payTime === 0
        ) {
            console.log('被收费的车俩', data);
            store.commit('SETCHARGECAR', data)
        }
    }


    const updateInterface = async (message) => {
        console.log("心跳收到的消息", message);
        if (message == null) return;
        //修改消息状态为已读
        let consumptionData = initNullMessagePojo();
        consumptionData.type = "change_status";
        consumptionData.cfUserMessage.id = message.cfUserMessage.id;
        websocket.send(JSON.stringify(consumptionData));
        // 将数据放到页面中进行展示
        let carParkUseLog = JSON.parse(message.cfUserMessage.contents);
        // console.log('carParkUseLog',carParkUseLog);
        console.log(carParkUseLog);
        const { data } = await selectPackageListByQuery({
            carParkId: carParkUseLog.carParkId,
            numberPlate: carParkUseLog.numberPlate,
        });
        carParkUseLog.data = data[0]
        if (message.cfUserMessage.type == 1) {
            if (carParkUseLog.inTime > 0 && carParkUseLog.outTime == 0) {
                // this.nowInBigImage = carParkUseLog.inBigImage;
                carParkUseLog.cfCarParkCarType =
                    data == null
                        ? { name: "临时车", flagKey: "temporary_car" }
                        : data[0].cfCarParkCarType;
                console.log("查询车辆的套餐", data);
                pushStoreData(carParkUseLog, 'in')
                // 黑名单
                console.log(carParkUseLog, '车辆信息')
                if (carParkUseLog.data.cfCarParkCarType.name == '黑名单') {
                    notifStoreData(carParkUseLog)
                }
                if (carParkUseLog.data.cfCarParkCarType.name == '月租车') {
                    if (!dayjs(carParkUseLog.data.endTime).isAfter(dayjs())) {
                        notifStoreData(carParkUseLog)
                    }
                }
            }
            // 更新界面:包括 图片 消息 更新到页面
            // 只提示选中停车场的停车数据
            if (carParkUseLog.carParkId == store.getters.carParkId) {
                const direction = carParkUseLog.outTime == 0 ? " 车牌进场：" : "车牌出场：";
                const name = carParkUseLog.outTime == 0 ? carParkUseLog.cfCarParkCheckpointIn.name : carParkUseLog?.cfCarParkCheckpointOut?.name;
                if (store.state.globalConfig.promptEntryExitCar) {
                    let msg
                    if (name) {
                        msg = name + direction + carParkUseLog.numberPlate
                    } else {
                        msg = direction + carParkUseLog.numberPlate
                    }
                    ElNotification({
                        title: '提示',
                        message: msg,
                        position: "bottom-left",
                        type: 'warning',
                    });
                }
            }

            // 出场查询账单
            if (carParkUseLog.outTime > 0) {
                getQueryOrderByUseId(carParkUseLog);
            }
        } else {
            // 用户已支付 取消弹窗
            console.log('已支付的车辆信息', carParkUseLog)
            store.commit('PAIDCAR', carParkUseLog)
            // this.$refs.ChargeBox.deleteData(carParkUseLog);
        }
    }

    // const getWsUrl = () => {

    // }
    let limitConnect = 30;  // 断线重连次数
    let timeConnect = 0;
    if (window.WebSocket) {
        store.commit('SETERRARY', [])
        // let obj = {
        //     "carNumberPlateColor": 1,
        //     "carParkId": "1526402049384648704",
        //     "carType": "temporary_car",
        //     "cfCarParkCheckpointIn": {
        //         "addForbiddenData": 0,
        //         "allowExpiredCar": 1,
        //         "allowPackageCar": 1,
        //         "allowTemporaryCar": 1,
        //         "allowUnconditionalOpen": 0,
        //         "carParkId": "1526402049384648704",
        //         "defaultCheckPoint": 1,
        //         "direction": "in",
        //         "dutyUid": "1526411864521687040",
        //         "floor": 0,
        //         "id": "1526770112567185408",
        //         "mode": 0,
        //         "name": "入口",
        //         "positionDescribe": "风雨测试",
        //         "positionX": 0,
        //         "positionY": 0,
        //         "status": 0
        //     },
        //     "cfCarParkCheckpointOut": {},
        //     "cfCarParkDevice": {
        //         "barCode": "dcababe7-bb8c7b2e",
        //         "brand": "zhen_shi",
        //         "carParkId": "1526402049384648704",
        //         "checkpointId": "1526770112567185408",
        //         "direction": "in",
        //         "historyVideoAddress": "",
        //         "id": "1544515429593075712",
        //         "indexNo": 0,
        //         "ip": "192.168.1.231",
        //         "lastOnlineTime": 1657076138000,
        //         "linkMode": "mqtt",
        //         "macAddress": "",
        //         "model": "R3",
        //         "noticed": 0,
        //         "password": "",
        //         "playContents": "{\"approach\":{\"textPlay\":{\"1\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"green\",\"inMode\":\"right_to_left\",\"outMode\":\"right_to_left\",\"status\":0,\"serialChannel\":0},\"2\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"yellow\",\"inMode\":\"buttom_to_top\",\"outMode\":\"buttom_to_top\",\"status\":0,\"serialChannel\":0},\"3\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"red\",\"inMode\":\"top_to_buttom\",\"outMode\":\"top_to_buttom\",\"status\":0,\"serialChannel\":0},\"4\":{\"type\":\"plaintext\",\"value\":\"欢迎光临,请减速慢行\",\"color\":\"green\",\"inMode\":\"right_to_left\",\"outMode\":\"right_to_left\",\"status\":1,\"serialChannel\":0}},\"voicePlay\":{\"1\":{\"value\":\"\",\"playMode\":\"only_add\",\"status\":0,\"serialChannel\":0,\"type\":\"plaintext\"},\"2\":{\"value\":\"\",\"playMode\":\"only_add\",\"status\":0,\"serialChannel\":0,\"type\":\"plaintext\"},\"3\":{\"value\":\"\",\"playMode\":\"add_and_play\",\"status\":0,\"serialChannel\":0,\"type\":\"plaintext\"}},\"imagePlay\":\"\",\"videoPlay\":\"\",\"deviceModel\":\"miu_new\"},\"freeOut\":{\"textPlay\":{\"1\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"green\",\"inMode\":\"right_to_left\",\"outMode\":\"right_to_left\",\"status\":0,\"serialChannel\":0},\"2\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"yellow\",\"inMode\":\"buttom_to_top\",\"outMode\":\"buttom_to_top\",\"status\":0,\"serialChannel\":0},\"3\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"red\",\"inMode\":\"top_to_buttom\",\"outMode\":\"top_to_buttom\",\"status\":0,\"serialChannel\":0},\"4\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"green\",\"inMode\":\"right_to_left\",\"outMode\":\"right_to_left\",\"status\":0,\"serialChannel\":0}},\"voicePlay\":{\"1\":{\"value\":\"\",\"playMode\":\"only_add\",\"status\":0,\"serialChannel\":0,\"type\":\"plaintext\"},\"2\":{\"value\":\"\",\"playMode\":\"only_add\",\"status\":0,\"serialChannel\":0,\"type\":\"plaintext\"},\"3\":{\"value\":\"\",\"playMode\":\"add_and_play\",\"status\":0,\"serialChannel\":0,\"type\":\"plaintext\"}},\"imagePlay\":\"\",\"videoPlay\":\"\",\"deviceModel\":\"miu_new\"},\"payOut\":{\"textPlay\":{\"1\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"green\",\"inMode\":\"right_to_left\",\"outMode\":\"right_to_left\",\"status\":0,\"serialChannel\":0},\"2\":{\"type\":\"fee\",\"value\":\"请缴费{$fee}元\",\"color\":\"red\",\"inMode\":\"right_to_left\",\"outMode\":\"right_to_left\",\"status\":0,\"serialChannel\":0},\"3\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"yellow\",\"inMode\":\"buttom_to_top\",\"outMode\":\"buttom_to_top\",\"status\":0,\"serialChannel\":0},\"4\":{\"type\":\"duration\",\"value\":\"停车时长{$duration}\",\"color\":\"green\",\"inMode\":\"right_to_left\",\"outMode\":\"right_to_left\",\"status\":0,\"serialChannel\":0}},\"voicePlay\":{\"1\":{\"value\":\"\",\"playMode\":\"only_add\",\"status\":0,\"serialChannel\":0,\"type\":\"plaintext\"},\"2\":{\"value\":\"\",\"playMode\":\"only_add\",\"status\":0,\"serialChannel\":0,\"type\":\"plaintext\"},\"3\":{\"value\":\"请缴费{$fee}元\",\"playMode\":\"add_and_play\",\"status\":0,\"serialChannel\":0,\"type\":\"fee\"}},\"imagePlay\":\"\",\"videoPlay\":\"\",\"deviceModel\":\"miu_new\"},\"abnormalOut\":{\"textPlay\":{\"1\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"green\",\"inMode\":\"right_to_left\",\"outMode\":\"right_to_left\",\"status\":0,\"serialChannel\":0},\"2\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"yellow\",\"inMode\":\"buttom_to_top\",\"outMode\":\"buttom_to_top\",\"status\":0,\"serialChannel\":0},\"3\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"red\",\"inMode\":\"top_to_buttom\",\"outMode\":\"top_to_buttom\",\"status\":0,\"serialChannel\":0},\"4\":{\"type\":\"plaintext\",\"value\":\"\",\"color\":\"green\",\"inMode\":\"right_to_left\",\"outMode\":\"right_to_left\",\"status\":0,\"serialChannel\":0}},\"voicePlay\":{\"1\":{\"value\":\"\",\"playMode\":\"only_add\",\"status\":0,\"serialChannel\":0,\"type\":\"plaintext\"},\"2\":{\"value\":\"\",\"playMode\":\"only_add\",\"status\":0,\"serialChannel\":0,\"type\":\"plaintext\"},\"3\":{\"value\":\"\",\"playMode\":\"add_and_play\",\"status\":0,\"serialChannel\":0,\"type\":\"plaintext\"}},\"imagePlay\":\"\",\"videoPlay\":\"\",\"deviceModel\":\"miu_new\"}}",
        //         "productId": "123",
        //         "rows": 4,
        //         "status": 1,
        //         "type": 2,
        //         "username": "",
        //         "videoAddress": "",
        //         "videoMode": "local"
        //     },
        //     "createPosition": "out",
        //     "createTime": 1657162064698,
        //     "id": "1544875787067412480",
        //     "inBigImage": "http://cdn-aliyun.tutuhy.com/picture/0/dcababe7-bb8c7b2e/20220707/10/20220707_104745_391.jpg",
        //     "inCheckPointId": "1526770112567185408",
        //     "inHandleUid": "1526411864521687040",
        //     "inReleaseType": 1,
        //     "inSmallImage": "http://cdn-aliyun.tutuhy.com/picture/0/dcababe7-bb8c7b2e/20220707/10/20220707_104745_391_plate.jpg",
        //     "inTime": 1657162065000,
        //     "numberPlate": "闽D8659X",
        //     "outBigImage": "",
        //     "outCheckPointId": "",
        //     "outHandleUid": "",
        //     "outReleaseType": 0,
        //     "outSmallImage": "",
        //     "outTime": 0,
        //     "payTime": 0,
        //     "releaseNotice": "闽D8659X 车辆进场",
        //     "remarks": "",
        //     "cfCarParkCarType": {
        //         "id": "1539524409503600640",
        //         "name": "月租车",
        //         "flagKey": "blacklist",
        //         "image": "",
        //         "description": "黑名单车辆",
        //         "sortIndex": 0
        //     },
        //     "data": {
        //         "id": null,
        //         "carParkId": null,
        //         "carParkIds": null,
        //         "typeKey": null,
        //         "startTime": null,
        //         "endTime": 1660267609000,
        //         "createTime": null,
        //         "uid": null,
        //         "numberPlate": null,
        //         "specialGive": null,
        //         "packagePriceId": null,
        //         "transRegional": null,
        //         "mainCarParkId": null,
        //         "phone": null,
        //         "carParkName": null,
        //         "parentId": null,
        //         "userName": null,
        //         "name": null,
        //         "remarks": null,
        //         "carOwnerName": null,
        //         "cfCarParkCarType": {
        //             "id": "1539524409503600640",
        //             "name": "月租车",
        //             "flagKey": "blacklist",
        //             "image": "",
        //             "description": "黑名单车辆",
        //             "sortIndex": 0
        //         },
        //         "groupFlag": null,
        //         "status": null,
        //         "issuedWhitelist": null,
        //         "issuedWhitelistTime": null,
        //         "noticeExpiringSoon": null,
        //         "noticeExpired": null,
        //         "specialCarId": null,
        //         "cfCarParkPackagePrice": null
        //     }
        // }
        // // let cfUserMessage = {
        // //     contents: JSON.stringify(obj),
        // //     id: '1526402049384648704',
        // //     type: 1
        // // }
        // // let msg = { cfUserMessage }
        // setTimeout(() => {
        //     // updateInterface(msg)
        //     notifStoreData(obj)
        // }, 3000);
        getMinChatLinkCountsServiceIp().then(res => {
            console.log(res);
            if (res.code != 10002) {
                ElMessage.error(res.message)
                return
            }
            newWebSocket(res)

        })
    } else {
        alert('您的浏览器不支持webSocket！')
    }
    const newWebSocket = (res) => {
        websocket = new ReconnectingWebSocket(`ws://${res.data}:9002/ws`);
        websocket.onopen = (e) => {
            console.log("账单WebSocket连接开启", e);
            limitConnect = 30
            timeConnect = 0
            store.state.isLive = true
            reateLinkAndSendheartBeat();
        };

        // 接受webSocket消息
        websocket.onmessage = (e) => {
            var message = JSON.parse(e.data);
            console.log('message', message);
            // 将数据放到页面中进行展示
            updateInterface(message);
        };

        websocket.onclose = (e) => {
            store.state.isLive = false
            localStorage.setItem('isError', new Date().getTime())
            console.log("账单WebSocket连接关闭", e);
            if (limitConnect > 0) {
                limitConnect--
                timeConnect++
                console.log(`第${timeConnect}次重连`)
                // newWebSocket(res)
                // window.location.reload()
            } else {
                errorFun(e)
            }
        }
    }

    const errorFun = (res) => {
        let time = new Date().getTime()
        let isError = localStorage.getItem('isError')
        if (time - isError > 30000) {
            localStorage.setItem('isError', time)
            ElMessage.error('账单WebSocket连接关闭')
            window.location.reload()
        } else {
            setTimeout(() => {
                errorFun(res)
            }, 3000);
        }

    }

}